import React, { useEffect, useState } from 'react';

const fases = [
  'Pensando...',
  'Analizando patrones...',
  'Pensando...',
  'Construyendo respuesta...'
];

const FasePensamiento = () => {
  const [faseIndex, setFaseIndex] = useState(0);

  useEffect(() => {
    if (faseIndex < fases.length - 1) {
      const timer = setTimeout(() => {
        setFaseIndex(prev => prev + 1);
      }, 6500);
      return () => clearTimeout(timer);
    }
  }, [faseIndex]);

  return (
    <span
      className="loading-text"
      style={{
        display: 'block',
        textAlign: 'rigth',
        fontSize: '1.2rem',
        padding: '1.5rem',
        minHeight: '50vh', // fuerza que el contenedor llegue al menos hasta la mitad de la pantalla
        marginBottom: '3rem' // da espacio extra debajo
      }}
    >
      {fases[faseIndex]}
    </span>
  );
};

export default FasePensamiento;
